<div class="flex flex-row justify-between items-center h-16 pl-5 bg-navy-90 rounded-tl-xl font-main text-white text-2xl">
  <div class="flex items-center">
    <svg-icon class="mr-3" [src]="'commenting/comment'"></svg-icon>
    {{ buildTranslationKey('commentsText') | translate }} ({{ overallCommentsCount$ | async }})
  </div>

  <app-cross-button data-test-id="close-panel-btn" class="mr-3" (click)="closePanel()"></app-cross-button>
</div>

<div class="flex flex-col flex-1 bg-white">
  <div class="flex justify-between items-center px-2.5 min-h-16 h-16 border-t border-b border-solid border-navy-30">
    @if (isSingleThreadDisplayed$ | async) {
      <div class="flex gap-x-1.5">
        @if ((shouldDisplayBackButton$ | async) && (hasUniqueSingleThreadDesign$ | async) === false) {
          <app-back-to-all-comments-action></app-back-to-all-comments-action>
        }

        <app-thread-state-filter [showIcon]="false"></app-thread-state-filter>
      </div>

      <div class="flex gap-x-1.5">
        <app-thread-sorting [isDisabled]="areCommentsEmpty$ | async"></app-thread-sorting>

        <ng-container *featureFlag="'@commenting-full-access'">
          @if (areActiveDisplayed$ | async) {
            <app-resolve-button
              [tooltipTranslationText]="buildTranslationKey('resolveAllBtn')"
              [isDisabled]="areCommentsEmpty$ | async"
              [placement]="'bottom-right'"
              (click)="resolveAll()"
            ></app-resolve-button>
          }
        </ng-container>
      </div>
    } @else {
      <app-thread-state-filter></app-thread-state-filter>

      <app-thread-sorting [isDisabled]="areCommentsEmpty$ | async"></app-thread-sorting>

      <ng-container *featureFlag="'@commenting-full-access'">
        @if (areActiveDisplayed$ | async) {
          <app-resolve-button
            [tooltipTranslationText]="buildTranslationKey('resolveAllBtn')"
            [isDisabled]="areCommentsEmpty$ | async"
            [placement]="'bottom-right'"
            (click)="resolveAll()"
          ></app-resolve-button>
        }

        @if (areResolvedDisplayed$ | async) {
          <app-delete-all-action [isDisabled]="areCommentsEmpty$ | async"></app-delete-all-action>
        }
      </ng-container>
    }
  </div>

  @if (areCommentsEmpty$ | async) {
    <app-no-comments-empty-state></app-no-comments-empty-state>
  }
  <div class="w-full h-full" [class.hidden]="(isSingleThreadDisplayed$ | async) === false">
    <app-virtual-scroll-renderer
      #renderer
      class="w-full h-full"
      [allItemsStream]="threads$"
      [filteredItemsStream]="filter$"
      [idSelector]="resourceIdSelector"
      [scrollToNewlyAddedItem]="true"
    >
      <ng-template #itemTemplate let-item="item">
        <app-thread-item [auditorSimulationMode]="['pointer-events-none']" [resource]="item"></app-thread-item>
      </ng-template>
    </app-virtual-scroll-renderer>
  </div>

  <div class="w-full h-full" [class.hidden]="isSingleThreadDisplayed$ | async">
    <app-virtual-scroll-renderer
      #renderer
      class="w-full h-full"
      [allItemsStream]="threadsGroup$"
      [filteredItemsStream]="threadsGroup$"
      [idSelector]="groupIdSelector"
      [scrollToNewlyAddedItem]="true"
    >
      <ng-template #itemTemplate let-item="item">
        <app-thread-group-view [threadGroup]="item"></app-thread-group-view>
      </ng-template>
    </app-virtual-scroll-renderer>
  </div>

  <ng-container *ngVar="shouldDisableAddCommentButton$ | async as shouldDisableAddCommentButton">
    @if (isSingleThreadDisplayed$ | async) {
      <div
        data-test-id="add-new-comment-button"
        class="px-3 py-4 border border-navy-30 border-solid"
        [ngClass]="{
          'pointer-events-none': shouldDisableAddCommentButton,
        }"
        (click)="addNewComment()"
      >
        <app-new-button
          class="w-full justify-center"
          [type]="'primary'"
          [svgIconPath]="'Add'"
          [disabled]="shouldDisableAddCommentButton"
        >
          {{ buildTranslationKey('addNewCommentBth') | translate }}
        </app-new-button>
      </div>
    }
  </ng-container>
</div>
